import { toast, ToastOptions } from 'react-toastify';

const DEFAULT_OPTIONS: ToastOptions = {
    position: 'bottom-center',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
    toastId: 'default',
};

const Notification = {
    success: (message = 'Success!') => toast.success(message, DEFAULT_OPTIONS),
    warning: (message = 'Warning!') => toast.warning(message, DEFAULT_OPTIONS),
    error: (message = 'Sorry, something went wrong') => toast.error(message, DEFAULT_OPTIONS),
    isActive: () => toast.isActive('default')
};

export default Notification;